import React from 'react';

export const StatusPopup = ({ statusPopupObject, setShowStatusPopup }) => {
	console.log(statusPopupObject);

	const closePopup = () => {
		setShowStatusPopup(false);
	};

	return (
		<div className="status-popup-container">
			<div className="status-popup-inner">
				{statusPopupObject.type === 'success' ? (
					<div className="banner-left-container">
						<div className="colour-banner-green" />
						<i className="fas fa-check-circle" id="success-icon" />
					</div>
				) : (
					<div className="banner-left-container">
						<div className="colour-banner-red" />
						<i className="fas fa-times-circle" id="failed-icon" />
					</div>
				)}
				<p className="body-font">{statusPopupObject.text}</p>
				<i
					id="close-button"
					className="fas fa-times"
					onClick={closePopup}
				/>
			</div>
		</div>
	);
};
